import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const ApprovalService = {
  approveLeave(obj) {
    return httpClient.post(endPoints.approveLeave, obj);
  },
  approveOutdoorwork(obj) {
    return httpClient.post(endPoints.approveOutdoorwork, obj);
  },
  rejectLeave(obj) {
    return httpClient.post(endPoints.rejectLeave, obj);
  },
  rejectOutdoorwork(obj) {
    return httpClient.post(endPoints.rejectOutdoorwork, obj);
  },
  getOutdoorkwork(obj) {
    return httpClient.post(endPoints.getApprovalOutdoorkwork, obj);
  },
  getLeave(obj) {
    return httpClient.post(endPoints.getApprovalLeave, obj);
  }
};

export default ApprovalService;



// WEBPACK FOOTER //
// ./src/service/ApprovalService.js